import * as React from 'react';
import cn from 'clsx';
import { IconFunctionalInformationCircle24, UIHeading4, UIText1 } from '@cian/ui-kit';

import { TNotificationType } from '../../types';

import * as styles from './styles.css';

export interface INotificationItemProps {
  type: TNotificationType;
  title?: string;
  icon?: React.ReactNode;
  message?: React.ReactNode;
  actions?: React.ReactNode;
  linked?: boolean;
  testId?: string;
}

export const NotificationItem: React.FC<INotificationItemProps> = props => {
  const { icon, title, message, actions, testId, type, linked = false } = props;

  return (
    <div className={cn(styles['container'], styles[type], linked && styles['linked'])} data-testid={testId}>
      <div className={styles['icon-area']}>
        <div className={styles['icon']}>{icon || <IconFunctionalInformationCircle24 color="current_color" />}</div>
        {linked && <span className={styles['link']} />}
      </div>
      <div className={styles['content-area']}>
        {title && <UIHeading4 as="h4">{title}</UIHeading4>}
        {message && <UIText1 as="div">{message}</UIText1>}
        {actions && <div className={styles['actions-area']}>{actions}</div>}
      </div>
    </div>
  );
};
